import { createAsyncThunk } from "@reduxjs/toolkit";
import apiRequest from "./apiRequest";

const fetchCart = createAsyncThunk("cart/fetch", async (userid) => {
  try {
    const response = await apiRequest.get(`/cart/${userid}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
});

export { fetchCart };
